export const LINKED_DATA_SCHEMA = {
  default: 'website',
  website: 'website',
  article: 'article',
  none: 'none',
};
